export default {
  path: '/settings',
  name: 'settings',
  component: () => import('@/views/Settings/Index.vue'),
  children: [
    {
      path: 'profile',
      name: 'setting profile',
      component: () => import('@/views/Settings/Profile.vue'),
    },
    {
      path: 'general-practitioner',
      name: 'setting general practitioner',
      component: () => import('@/views/Settings/GeneralPractitioner.vue'),
    },
    {
      path: 'email',
      name: 'setting email',
      component: () => import('@/views/Settings/Email.vue'),
    },
    {
      path: 'password',
      name: 'setting password',
      component: () => import('@/views/Settings/Password.vue'),
    },
  ],
}
